import LeaderContainer from './LeaderContainer';

export default LeaderContainer;
